/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from "react-redux";
import { message, Alert, Select, Typography } from 'antd';
import { Header, TabsHeader } from "datastake-daf/dist/components";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import configSubject from './config';
import Loading from "../../Loading";
import { DDTable } from "./table/ddTable";
import { PublicationTable } from "./table";
import { actions as sclActions } from '../../../store/reducers/scl';
import { actions as lirActions } from '../../../store/reducers/lir';
import { getLirFilterOptions, mapLirs } from "../../Forms/lir/helper";
import { getLocationFilterOptions } from "../../Forms/locations/helper";
import { actions as eventsActions } from '../../../store/reducers/events';
import { actions as projectActions } from '../../../store/reducers/project';
import { getEventFilterOptions, mapEvents } from "../../Forms/events/helper";
import { actions as stakeholderActions } from '../../../store/reducers/stakeholder';
import { getStakeholderFilterOptions, mapStakeholders } from "../../Forms/stakeholder/helper";
import { renderBreadCrumbs } from '../../../helpers/breadCrumbs';
import { useRef } from 'react';

const defaultState = {
  data: [], totalItems: 0, options: {}, loaded: false,
};
const defaultShownSections = {
  events: false, stakeholders: false, locations: false, network: false, dueDiligence: false
};

const Styles = styled.div`
  background: #f9fafb;

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
  }

  .type-select-cont {
    display: flex;
    flex-direction: column;
    margin-right: 12px;
  }

  .ant-col {
    padding: 0px 5px;
  }

  #under-nav-tabs #tab-1:first-of-type {
    margin-left: var(--size);
  }

  .view-toggle {
    width: 80px;
  }

  .app-content {
    background: #f9fafb;
    padding: var(--size-lg);
    height: calc(100% - 154px);
  }
`;

function ProjectPublications({
  authentication: { user },
  project: { data: { projects }, invitations, reports },
  scl: { data: { scls, sclOptions } },
  stakeholder: { data: { stakeholders, stakeholderOptions } },
  events: { data: { events, eventsOptions } },
  lir: { data: { lirs, lirOptions } },
  ProjectsGet,
  CaddReportsGet,
  stakeholderGet,
  eventsGet,
  lirGet,
  UpdatePublications,
  module,
}) {
  const goTo = useNavigate();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const config = configSubject.filter(c => c.modules.includes(module));
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(projects ? projects.find(p => p.datastakeId === id) : null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAll, setSelectedAll] = useState({
    events: [],
    stakeholders: [],
    locations: [],
    network: [],
    dueDiligence: [],
  });

  const [shownSection, setShownSection] = useState(defaultShownSections);
  const [retrievedDataForTab, setTabRetrieved] = useState([]);
  const [tabValue, setTabValue] = useState(params.get('tabValue') || 'unPublished');
  const activeTabs = ((data || {}).shareInfo || []).reduce((cfg, key) => {
    if (['events', 'stakeholders', 'locations', 'network', 'dueDiligence'].includes(key)) {
      const isNetwork = key === 'network';
      if (isNetwork) {
        key = 'lir'
      }
      cfg[key] = {
        all: true,
      }
    }
    return cfg;
  }, {});

  const [loadingDds, setLoadingDds] = useState(true);
  const [activeTab, setActiveTab] = useState(
    params.has('activeTab')
      ? params.get('activeTab')
      : Object.keys(activeTabs).length
        ? Object.keys(activeTabs)[0]
        : undefined
  );
  const [activeFiltersAll, setActiveFiltersAll] = useState({
    events: {},
    stakeholders: {},
    locations: {},
    network: {},
    lir: {},
    dueDiligence: {},
  });
  const [tablesData, setTablesData] = useState({
    locations: { published: defaultState, unPublished: defaultState },
    stakeholders: { published: defaultState, unPublished: defaultState },
    events: { published: defaultState, unPublished: defaultState },
    lir: { published: defaultState, unPublished: defaultState },
  });
  const [rowSelectionMode, setRowSelectionMode] = useState({
    events: 'all',
    stakeholders: 'all',
    locations: 'all',
    network: 'all',
    dueDiligence: 'all',
    lir: 'all',
  });
  const [unpublishedCountAll, setUnpublishedCountAll] = useState({
    events: 0,
    stakeholders: 0,
    locations: 0,
    network: 0,
    dueDiligence: 0,
    lir: 0,
  });
  const [rowSelectionExcluded, setRowSelectionExcluded] = useState({
    events: [],
    stakeholders: [],
    locations: [],
    network: [],
    dueDiligence: [],
    lir: [],
  });
  const [tables, setTables] = useState({
    locations: [],
    stakeholders: [],
    events: [],
    lir: [],
    dueDiligence: [],
  });
  const notifications = useSelector((state) => state.notifications);
  const setStateTableData = useCallback((state, d) => {
    setTablesData((prev) => ({
      ...prev,
      [state]: {
        ...prev[state],
        ...d,
      },
    }));
  }, []);
  const [reset, setReset] = useState(false);

  const setUnpublishedCount = useCallback((data, tab) => {
    setUnpublishedCountAll((prev) => ({ ...prev, [tab]: data }));
  }, [])

  const setActiveFilters = useCallback((data, tab) => {
    setActiveFiltersAll((prev) => ({ ...prev, [tab]: data }));
  }, [])

  useEffect(() => {
    setShownSection((prev) => ({ ...prev, [activeTab]: true }));
  }, [activeTab]);

  const selected = useMemo(() => {
    return selectedAll[activeTab] || [];
  }, [selectedAll, activeTab])

  const setSelected = useCallback((data) => {
    setSelectedAll((prev) => ({ ...prev, [activeTab]: data }));
  }, [activeTab])

  const selectionMode = useMemo(() => rowSelectionMode[activeTab] || 'all',
    [rowSelectionMode, activeTab])
  const setSelctionMode = useCallback((data) => {
    setRowSelectionMode((prev) => ({ ...prev, [activeTab]: data }));
  }, [activeTab])

  const selectionExcluded = useMemo(() => rowSelectionExcluded[activeTab] || 'all',
    [rowSelectionExcluded, activeTab])
  const setSelctionExcluded = useCallback((data) => {
    setRowSelectionExcluded((prev) => ({ ...prev, [activeTab]: data }));
  }, [activeTab])

  const rowSelection = useMemo(() => ({
    type: 'checkbox',
    getCheckboxProps: record => ({
      datastakeId: record.id,
    }),
    rowSelectionMode: selectionMode,
    setRowSelectionMode: setSelctionMode,
    rowSelectionExcluded: selectionExcluded,
    setRowSelectionExcluded: setSelctionExcluded,
    clean: () => {
      setSelected([]);
      setSelctionExcluded([]);
      setSelctionMode('all');
    },
    selectedRowKeys: selected,
    onChange: selections => {
      setSelected(selections);
    },
  }), [selected, selectionExcluded, selectionMode, setSelected, setSelctionExcluded, setRowSelectionMode]);

  const selectedAllLength = useMemo(() => {
    return Object.keys(selectedAll).reduce((all, key) => {
      const mode = rowSelectionMode[key];
      const unpublishedLength = unpublishedCountAll[key];
      let excluded = [];
      const allSelected = new Set();

      (selectedAll[key] || []).forEach((item) => {
        allSelected.add(item.id);
      });

      (rowSelectionExcluded[key] || []).forEach((item) => {
        const _foundIndex = excluded.findIndex((it) => it.id === item.id);
        if (_foundIndex !== -1) {
          excluded[_foundIndex].count++;
        } else {
          excluded.push({ count: 1, versions: item.versions, id: item.id });
        }
      });

      excluded = excluded.filter((e) => e.versions === e.count);

      const length = (mode === 'all' || !mode) ? allSelected.size : unpublishedLength - excluded.length;

      return all + length;
    }, 0);
  }, [selectedAll, activeTab, rowSelectionMode, rowSelectionExcluded])

  const _reset = () => {
    setTabRetrieved([]);
    setSelected([]);
    setShownSection({
      ...defaultShownSections,
      [activeTab]: true,
    });

    setReset(true);
  };

  const publishingProject = useMemo(() => {
    return !!notifications.find(
      (noti) => noti.namespace === 'Publication' && noti.status === 'started'
    );
  }, [notifications]);

  useEffect(() => {
    if (!publishingProject) {
      _reset();
    }

  }, [publishingProject]);

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  const calls = {
    // sclsGet: getALL,
    stakeholdersGet: stakeholderGet,
    eventsGet,
    lirGet,
    reportingGet: (_, signal) => {
      setLoadingDds(true);
      return CaddReportsGet({ id: data.id, userId: user.company?.id, query: { view: 'publication' } }, () => setLoadingDds(false), signal)
    },
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (projects && projects.length) {
      const selectedProject = projects.find(p => p.datastakeId === id);
      if (selectedProject) {
        setData({
          ...selectedProject,
        })
        if (!activeTab && Object.keys(activeTabs).length) {
          setActiveTab(Object.keys(activeTabs)[0])
        }
      }
    } else {
      ProjectsGet({ namespace: 'PMEProject', module: 'pme', view: 'project' });
    }
  }, [projects]);

  // eslint-disable-next-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (data && activeTab && !retrievedDataForTab.includes(activeTab)) {
      setTabRetrieved([
        ...retrievedDataForTab,
        activeTab,
      ]);
      const { call, component } = config.find(c => c.state === activeTab);
      if (component !== 'newTable' && !isLoading) {
        calls[call](data ? { view: 'publication', country: data.country, project: data.id, administrativeLevel1: data.provinces } : null);
        setIsLoading(true);
      }
    }
  }, [activeTab, data, retrievedDataForTab]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setTables(Object.assign({
      // locations: scls ? mapLocations(scls, sclOptions) : [],
      stakeholders: stakeholders ? mapStakeholders(stakeholders, stakeholderOptions, 0) : [],
      events: events ? mapEvents(events, eventsOptions) : [],
      lir: lirs ? mapLirs(lirs, lirOptions, 0) : [],
      dueDiligence: reports ? reports : [],
    }, {}));
    setIsLoading(false);
  }, [scls, stakeholders, events, lirs, reports]);

  const getEntityOptions = {
    locations: () => getLocationFilterOptions(sclOptions),
    stakeholders: () => getStakeholderFilterOptions(stakeholderOptions),
    lir: () => getLirFilterOptions(lirOptions),
    events: () => getEventFilterOptions(eventsOptions),
    dueDiligence: () => [],
  }

  const publishData = (selectedItems, active, params) => {
    setIsLoading(true);
    _reset();
    UpdatePublications({
      projectId: data.id,
      rowSelectionMode,
      activeFiltersAll,
      rowSelectionExcluded,
      selectedAll,
      config,
      entity: active.entity,
      selected: selectedItems,
    }, (type, m) => {
      setRowSelectionMode({ events: 'all', stakeholders: 'all', locations: 'all', network: 'all', dueDiligence: 'all' });
      setUnpublishedCountAll({ events: 0, stakeholders: 0, locations: 0, network: 0, dueDiligence: 0, })
      setRowSelectionExcluded({ events: [], stakeholders: [], locations: [], network: [], dueDiligence: [] });
      setSelectedAll({ events: [], stakeholders: [], locations: [], network: [], dueDiligence: [] });

      message.success(m);
      setSelected([]);
      tables.dueDiligence = tables.dueDiligence.map(item => {
        if (selectedAll.dueDiligence.includes(item.dbId)) {
          if (!item.pmeProject) {
            item.pmeProject = [];
          }
          if (!item.pmeProject.includes(data.id)) {
            item.pmeProject.push(data.id);
          }
        }
        return item;
      });
      setTables({
        ...tables
      })
      if (active.component === 'newTable') {
        setStateTableData(active.state, { published: defaultState, unPublished: defaultState });
      }
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    });
  }

  const getConfirmText = (all = false) => {
    return `${t('Are you sure that you want to publish')} ${selectedAllLength} ${t('subjects')}?`;
  }

  let extraButtons = [];

  const selectOption = (
    <div className="type-select-cont">
      <Select
        style={{ width: 155 }}
        defaultValue={activeTab}
        value={activeTab}
        disabled={publishingProject}
        onChange={(idx) => {
          setActiveTab(idx);
        }}>
        {config.filter(e =>
          Object.keys(activeTabs).includes(e.state) &&
          Object.keys(activeTabs[e.state]).every(k => activeTabs[e.state][k] === true)).map((entity, idx) => (
            <Select.Option key={entity.state} value={entity.state}>
              <Typography.Text ellipsis={{ tooltip: t(entity.title) }} style={{ maxWidth: 110, verticalAlign: 'middle' }}>
                {t(entity.title)}
              </Typography.Text>
            </Select.Option>
          ))}
      </Select>
    </div>
  );

  const ddData = useMemo(() => {
    const unPublished = tables['dueDiligence'].filter(item => !(item.pmeProject || []).includes(data.id))
    const published = tables['dueDiligence'].filter(item => (item.pmeProject || []).includes(data.id))
    return { published, unPublished }
  }, [tables, data]);

  if (activeTab) {
    extraButtons = [
      {
        popConfirm: {
          disabled: selectedAllLength === 0,
          placement: "bottom",
          title: getConfirmText(false),
          onConfirm: () => {
            const active = config.find(c => c.state === activeTab);
            publishData([], active);

            // if (active && active.component === 'newTable') {
            //   publishData([], active);
            //   return;
            // }

            // const selectedItems = tables[active.state]
            //   .filter(item => selected.includes(item.datastakeId || item.id))
            //   .map(item => item.dbId);
            // if (selectedItems.length) {
            //   publishData(selectedItems, active);
            // }
          },
          okText: t('Yes'),
          cancelText: t('No'),
        },
        disabled: publishingProject || selectedAllLength === 0,
        type: "primary",
        label: t("Publish"),
      },
    ]
  }

  const breadcrumbs = useMemo(() => renderBreadCrumbs({ t, view: 'publishProject', id, goTo, mod: module }), [t, goTo, module, id]);

  return (isLoading) ? <Loading /> : <Styles className="form-input-output">
    <div className="shadow-header header-tabs-cont no-flex-tabs-cont">
      <Header
        title={t("Publish Data")}
        tooltip={t('Select subjects and publish to populate your projects with data.')}
        actionButtons={extraButtons}
        breadcrumbs={breadcrumbs}
      />
      <TabsHeader
        value={tabValue}
        onChange={(idx) => {
          setTabValue(idx);
        }}
        tabs={[
          {
            value: 'unPublished',
            label: t('Unpublished'),
          },
          {
            value: 'published',
            label: t('Published'),
          },
        ]}
      />
    </div>
    <div className="column start app-content">
      {(config.length === 0 || !activeTab) ? (
        <Alert
          message={t('You need at least a subject to share with this project in order to publish data on that')}
          type="warning"
          showIcon
          style={{ marginTop: 18 }}
        />
      ) : null}

      {config.filter(e =>
        Object.keys(activeTabs).includes(e.state) &&
        Object.keys(activeTabs[e.state]).every(k => activeTabs[e.state][k] === true))
        .filter((entity) => shownSection[entity.state])
        .map((entity, idx) => (
          <div key={entity.state} style={{ display: activeTab === entity.state ? undefined : 'none' }}>
            {entity.component === 'newTable' ? (
              <PublicationTable
                data={data}
                t={t}
                reset={reset}
                activeTab={activeTab}
                options={getEntityOptions[entity.state]()}
                columns={entity.columns(t, module, entity.state, 'publication')}
                published={tablesData[entity.state].published}
                selectOption={selectOption}
                unPublished={tablesData[entity.state].unPublished}
                setActiveFilters={(data) => setActiveFilters(data, entity.state)}
                tabValue={tabValue}
                setUnpublishedCountAll={(val) => setUnpublishedCount(val, entity.state)}
                setData={(data) => {
                  setStateTableData(entity.state, data);
                }}
                state={entity.state}
                rowSelection={rowSelection}
              />
            ) : (
              <DDTable
                options={getEntityOptions[entity.state]()}
                columns={entity.columns(t, module, 'locations', 'publication')}
                published={ddData.published}
                unPublished={ddData.unPublished}
                loading={loadingDds}
                activeTab={activeTab}
                setUnpublishedCountAll={(val) => setUnpublishedCount(val, entity.state)}
                selectOption={selectOption}
                tabValue={tabValue}
                t={t}
                mod={module}
                state={entity.state}
                rowSelection={rowSelection}
              />
            )}
          </div>
        ))}
    </div>
  </Styles >
}

const mstp = ({
  pme,
  authentication,
  location,
  project,
  scl,
  stakeholder,
  events,
  lir,
}) => ({
  pme,
  authentication,
  location,
  project,
  scl,
  stakeholder,
  events,
  lir
});

export default connect(mstp, {
  ...projectActions,
  ...sclActions,
  ...stakeholderActions,
  ...eventsActions,
  ...lirActions,
})(ProjectPublications);
